import { useI18n } from "nebula-mobile";

const i18n = useI18n();

i18n.addLanguageData({
  // 全局提示
  global_config: {
    submit: {
      zh_CN: "提交",
      zh_TW: "提交",
      en_US: "Submit",
    },
    confirm: {
      zh_CN: "确定",
      zh_TW: "確定",
      en_US: "OK",
    },
    success: {
      zh_CN: "成功",
      zh_TW: "成功",
      en_US: "Success",
    },
    know: {
      zh_CN: "知道了",
      zh_TW: "知道了",
      en_US: "OK",
    },
    cancel: {
      zh_CN: "取消",
      zh_TW: "取消",
      en_US: "Cancel",
    },
    loading: {
      zh_CN: "加载中...",
      zh_TW: "加載中...",
      en_US: "Loading...",
    },
    upload_image_check: {
      zh_CN: "请上传15M以内的图片",
      zh_TW: "請上傳15M以內的圖片",
      en_US: "Image size should not exceed 15M ",
    },
    upload_image_progress: {
      zh_CN: "图片正在上传中，请稍后提交",
      zh_TW: "圖片正在上傳中，請稍後提交",
      en_US: "Uploading，please try again later",
    },
    upload_video_check: {
      zh_CN: "请上传20M以内的视频",
      zh_TW: "請上傳20M以內的視頻",
      en_US: "Video size should not exceed 20M ",
    },
    upload_video_progress: {
      zh_CN: "视频正在上传中，请稍后提交",
      zh_TW: "視頻正在上傳中，請稍後提交",
      en_US: "Uploading，please try again later",
    },
    upload_video_type: {
      zh_CN: "仅支持png、jpg、jpeg、gif、mp4、mov格式",
      zh_TW: "僅支持png、jpg、jpeg、gif、mp4、mov格式",
      en_US: "Only PNG,JPG,JPEG,GIF,MP4,MOV format is supported",
    },
    upload_image_type: {
      zh_CN: "仅支持png、jpg、jpeg、gif的图片格式",
      zh_TW: "僅支持png、jpg、jpeg、gif的圖片格式",
      en_US: "Only PNG,JPG,JPEG,GIF format is supported",
    },
    project_title: {
      zh_CN: "客服中心",
      zh_TW: "客服中心",
      en_US: "Help Center",
    },
    yes: {
      zh_CN: "是",
      zh_TW: "是",
      en_US: "Yes",
    },
    no: {
      zh_CN: "否",
      zh_TW: "否",
      en_US: "No",
    },
    all: {
      zh_CN: "全部",
      zh_TW: "全部",
      en_US: "All",
    },
    work_time: {
      zh_CN: "客服工作时间：",
      zh_TW: "客服工作時間：",
      en_US: "Work time：",
    },
    everyday: {
      zh_CN: "每日",
      zh_TW: "每日",
      en_US: "",
    },
    weekdays: {
      zh_CN: "每工作日",
      zh_TW: "每工作日",
      en_US: "",
    },
    en_everyday: {
      zh_CN: "",
      zh_TW: "",
      en_US: "everyday",
    },
    en_weekdays: {
      zh_CN: "",
      zh_TW: "",
      en_US: "on weekdays",
    },
  },
  // 首页
  home: {
    faq: {
      zh_CN: "常见问题",
      zh_TW: "常見問題",
      en_US: "FAQ",
    },
    qa: {
      zh_CN: "问大家",
      zh_TW: "問大家",
      en_US: "Ask Others",
    },
    contact_service: {
      zh_CN: "联系客服",
      zh_TW: "聯系客服",
      en_US: "Feedback",
    },
    feedback: {
      zh_CN: "服务记录",
      zh_TW: "服務記錄",
      en_US: "My Feedback",
    },
  },
  // 竖屏指引
  vertical_screen: {
    portrait_screen_tip: {
      zh_CN: "为了更好的体验，请将手机/平板竖起",
      zh_TW: "為了更好的體驗，請將手機/平板豎起",
      en_US: "Please put your phone or pad in portrait for better  experience",
    },
    portrait_screen_remark: {
      zh_CN: "（若锁定了横屏，请先解除）",
      zh_TW: "（若鎖定了橫屏，請先解除）",
      en_US: " ",
    },
  },
  // SDK登陆前
  sdk_login_before: {
    mobile_tip: {
      zh_CN: "为了您的账号安全，请先进行手机验证。",
      zh_TW: "為了您的賬號安全，請先進行手機驗證。",
      en_US: "Please perform sms vertification for account security.",
    },
    mobile_contact: {
      zh_CN: "联系手机",
      zh_TW: "聯系手機",
      en_US: "Mobile Number",
    },
    mobile_code: {
      zh_CN: "短信验证码",
      zh_TW: "簡訊驗證碼",
      en_US: "Verification Code",
    },
    mobile_code_get: {
      zh_CN: "免费获取",
      zh_TW: "免費獲取",
      en_US: "Get SMS",
    },
    mobile_verify: {
      zh_CN: "验证并进入客服中心",
      zh_TW: "驗證並進入客服中心",
      en_US: "Verify",
    },
    email_tip: {
      zh_CN: "为了您的账号安全，请先进行邮箱验证；获取的验证码将发往您的邮箱。",
      zh_TW: "為了您的賬號安全，請先進行郵箱驗證；獲取的驗證碼將發往您的郵箱。",
      en_US:
        "Please verify your email  address for account security. Verification code will sent to your email address.",
    },
    email_contact: {
      zh_CN: "联系邮箱",
      zh_TW: "聯系郵箱",
      en_US: "Email Address",
    },
    email_code: {
      zh_CN: "邮箱验证码",
      zh_TW: "郵箱驗證碼",
      en_US: "Verification Code",
    },
    email_code_get: {
      zh_CN: "免费获取",
      zh_TW: "免費獲取",
      en_US: "Send",
    },
    email_verify: {
      zh_CN: "验证并进入客服中心",
      zh_TW: "驗證並進入客服中心",
      en_US: "Verify",
    },
    graph_code_tip: {
      zh_CN: "请输入图中验证码",
      zh_TW: "請輸入圖中驗證碼",
      en_US: "Please enter the captcha",
    },
    graph_code_change: {
      zh_CN: "看不清？点此换一张",
      zh_TW: "看不清？點此換一張",
      en_US: "Change",
    },
  },
  // SDK登陆后
  sdk_login_after: {
    server_select_tip: {
      zh_CN: "为了更快速地解决您遇到的问题，请先完善您的角色信息",
      zh_TW: "為了更快速地解決您遇到的問題，請先完善您的角色信息",
      en_US: "Please enter your role info for troubleshooting",
    },
    server_name: {
      zh_CN: "区服名称",
      zh_TW: "區服名稱",
      en_US: "Server Name",
    },
    role_name: {
      zh_CN: "角色名称",
      zh_TW: "角色名稱",
      en_US: "Role Name",
    },
    into_service: {
      zh_CN: "进入客服中心",
      zh_TW: "進入客服中心",
      en_US: "Next",
    },
    role_none: {
      zh_CN: "未创建/找到角色",
      zh_TW: "未創建/找到角色",
      en_US: "Not created or not found role",
    },
  },
  // 飞鱼游戏公众号入口
  wechat_enter: {
    serve_you: {
      zh_CN: "您好，很高兴为您服务",
      zh_TW: "您好，很高興為您服務",
      en_US: "Welcome, it's my pleasure to serve you",
    },
    my_feedback: {
      zh_CN: "服务记录",
      zh_TW: "服務記錄",
      en_US: "My Feedback",
    },
    select_game: {
      zh_CN: "请选择产品，进入对应客服专区",
      zh_TW: "請選擇產品，進入對應客服專區",
      en_US: "Please select the game",
    },
    no_result: {
      zh_CN: "抱歉，暂时找不到相关产品",
      zh_TW: "抱歉，暫時找不到相關產品",
      en_US: "Sorry, no results  matched",
    },
  },
  // 常见问题
  common_problem: {
    faq_search_placeholder: {
      zh_CN: "可在此输入您疑问的关键字，如“充值”等",
      zh_TW: "可在此輸入您疑問的關鍵字，如“充值”等",
      en_US: "Try keywords，such as 'pay' etc",
    },
    welcome_to: {
      zh_CN: "欢迎来到",
      zh_TW: "歡迎來到",
      en_US: "Welcome to",
    },
    help_center: {
      zh_CN: "客服专区",
      zh_TW: "客服專區",
      en_US: "help center",
    },
    faq_search_no_results: {
      zh_CN: "很抱歉，暂时找不到相关信息",
      zh_TW: "很抱歉，暫時找不到相關信息",
      en_US: "Sorry，no results  matched",
    },
    faq_search_no_more: {
      zh_CN: "很抱歉，暂无相关的常见问题",
      zh_TW: "很抱歉，暫無相關的常見問題",
      en_US: "Sorry，there are no more information",
    },
    was_helpful: {
      zh_CN: "本文对您是否有帮助",
      zh_TW: "本文對您是否有幫助",
      en_US: "Was this helpful？",
    },
    thank_feedback: {
      zh_CN: "感谢您的反馈",
      zh_TW: "感謝您的反饋",
      en_US: "Thank you",
    },
    invalid_answer: {
      zh_CN: "很抱歉没能为您解答，您可以点击",
      zh_TW: "很抱歉沒能為您解答，您可以點擊",
      en_US: "Sorry for being unable to help you，you can consult  by  ",
    },
    consulting_service: {
      zh_CN: "进行咨询哦",
      zh_TW: "進行咨詢哦",
      en_US: " ",
    },
  },
  contact_service: {
    question_type: {
      zh_CN: "问题类型",
      zh_TW: "問題類型",
      en_US: "Topic",
    },
    question_subcategory: {
      zh_CN: "具体子类",
      zh_TW: "具體子類",
      en_US: "Subcategory",
    },
    question_des: {
      zh_CN: "问题描述",
      zh_TW: "問題描述",
      en_US: "Description",
    },
    add_image: {
      zh_CN: "附加图片",
      zh_TW: "附加圖片",
      en_US: "Images for troubleshooting",
    },
    add_image_tip: {
      zh_CN: "（可加快客服处理速度）",
      zh_TW: "（可加快客服處理速度）",
      en_US: "",
    },
    too_many_tip: {
      zh_CN: "您提交的问题过多",
      zh_TW: "您提交的問題過多",
      en_US: "Too many issue in process",
    },
    waiting_for_reply: {
      zh_CN: "客服正在加速处理，请耐心等待回复",
      zh_TW: "客服正在加速處理，請耐心等待回復",
      en_US: "please wait for reply",
    },
    no_topic: {
      zh_CN: "暂无问题类型",
      zh_TW: "暫無問題類型",
      en_US: "No topic for the moment",
    },
    submit_success: {
      zh_CN: "问题提交成功",
      zh_TW: "問題提交成功",
      en_US: "Successful Feedback",
    },
    submit_success_tip: {
      zh_CN: "您可以在“服务记录”中查看处理进度。",
      zh_TW: "您可以在“服務記錄”中查看處理進度。",
      en_US: "Thanks for your feedback.You can see reply from 'My Feedback'.",
    },
    choose_time: {
      zh_CN: "选择时间",
      zh_TW: "選擇時間",
      en_US: "Select Time",
    },
    see_feedback: {
      zh_CN: "查看服务记录",
      zh_TW: "查看服務記錄",
      en_US: "See ‘My Feedback’",
    },
    same_topic_tip: {
      zh_CN: "您有相同类型的问题正在处理中，请耐心等待回复",
      zh_TW: "您有相同類型的問題正在處理中，請耐心等待回復",
      en_US: "Same topic in process，please wait for reply",
    },
  },
  feedback: {
    record_empty: {
      zh_CN: "仅显示近15天的服务记录",
      zh_TW: "僅顯示近15天的服務記錄",
      en_US: "Only feedback for the last 15 days was displayed.",
    },
    processing: {
      zh_CN: "处理中",
      zh_TW: "處理中",
      en_US: "Processing",
    },
    replied: {
      zh_CN: "已回复",
      zh_TW: "已回復",
      en_US: "Replied",
    },
    solved: {
      zh_CN: "已解决",
      zh_TW: "已解決",
      en_US: "Solved",
    },
    evaluated: {
      zh_CN: "已评价",
      zh_TW: "已評價",
      en_US: "Evaluated",
    },
    your_issue: {
      zh_CN: "您的提问",
      zh_TW: "您的提問",
      en_US: "Your issue",
    },
    reply: {
      zh_CN: "客服回复",
      zh_TW: "客服回復",
      en_US: "Reply",
    },
    your_add_desc: {
      zh_CN: "您的补充",
      zh_TW: "您的補充",
      en_US: "Your additional description",
    },
    your_issue_desc: {
      zh_CN: "请补充问题描述",
      zh_TW: "請補充問題描述",
      en_US: "Please describe your issue",
    },
    not_allow_add: {
      zh_CN: "暂不支持重复补充",
      zh_TW: "暫不支持重復補充",
      en_US: "Repeat submitting description is not allowed",
    },
    not_allow_evaluate: {
      zh_CN: "暂不支持重复评价",
      zh_TW: "暫不支持重復評價",
      en_US: "Repeat evaluating is not allowed",
    },
    not_solve_evaluate: {
      zh_CN: "问题尚未解决，暂不支持评价",
      zh_TW: "問題尚未解決，暫不支持評價",
      en_US: "Evaluating  should after issue solved",
    },
    submit_add_success: {
      zh_CN: "问题补充成功",
      zh_TW: "問題補充成功",
      en_US: "Successful Feedback",
    },
    delete_video: {
      zh_CN: "确认删除视频吗？",
      zh_TW: "確認刪除視頻嗎？ ",
      en_US: "Still delete the video？ ",
    },
    your_evaluate: {
      zh_CN: "您的评价",
      zh_TW: "您的評價",
      en_US: "Your evaluation",
    },
    evaluate_msg: {
      zh_CN: "感谢您的咨询，请对我们的服务做出评价",
      zh_TW: "感謝您的咨詢，請對我們的服務做出評價",
      en_US: "Thanks for your feedback.Please rate our service.",
    },
    evaluate_tip: {
      zh_CN: "我们有什么做的不足的吗？",
      zh_TW: "我們有什麽做的不足的嗎？",
      en_US: "Hope to know our inadequacies?",
    },
    evaluate_select_why: {
      zh_CN: "请选择不满意原因",
      zh_TW: "結果滿意，服務不滿意",
      en_US: "Satisfied with the results, not satisfied with the service",
    },
    evaluate_select_one: {
      zh_CN: "结果满意，服务不满意",
      zh_TW: "結果滿意，服務不滿意",
      en_US: "Satisfied with the results, not satisfied with the service",
    },
    evaluate_select_two: {
      zh_CN: "结果不满意，服务满意",
      zh_TW: "結果不滿意，服務滿意",
      en_US: "Not satisfied with the results, but satisfied with the service",
    },
    evaluate_select_three: {
      zh_CN: "结果和服务都不满意",
      zh_TW: "結果和服務都不滿意",
      en_US: "Not satisfied with the results and service",
    },
    evaluate_thanks: {
      zh_CN: "感谢您的评价",
      zh_TW: "感謝您的評價",
      en_US: "Thank you",
    },
    reply_time: {
      zh_CN: "回复时间",
      zh_TW: "回復時間",
      en_US: "Replied time",
    },
    excepted_reply_time: {
      zh_CN: "预计回复时间",
      zh_TW: "預計回復時間",
      en_US: "Expected reply time",
    },
    order_push: {
      zh_CN: "催办",
      zh_TW: "催辦",
      en_US: "Push",
    },
    order_pushed: {
      zh_CN: "已催办",
      zh_TW: "已催辦",
      en_US: "Pushed",
    },
    not_solved: {
      zh_CN: "问题还没得到解决？",
      zh_TW: "問題還沒得到解決？",
      en_US: "The issue hasn't been solved yet? ",
    },
    not_solved_supplement: {
      zh_CN: "请补充您尚未解决的问题",
      zh_TW: "請補充您尚未解決的問題",
      en_US: "Your additional description",
    },
  },
});

export const i18nService = i18n;
